import {
  AfterContentChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { forkJoin } from "rxjs";
import {
  DesnitrificacionViewModel,
  DigestionAnaerobiaFangoViewModel,
  PrimaIncluidaViewModel,
  RecuperacionFosforoViewModel,
  TipoUsoAguaViewModel,
} from "src/app/_core/models/centros/centro-list-base.model";
import { CentrosViewModel } from "src/app/_core/models/centros/centro.model";
import { DecimalService } from "src/app/_core/providers/decimals.service";
import { MasterService } from "src/app/_core/providers/master.service";
import { CentroPageComponent } from "../../../pages/centro/centro.page";

@Component({
  selector: "app-centro-operation-data-card",
  templateUrl: "./centro-operation-data-card.component.html",
  styleUrls: ["./centro-operation-data-card.component.scss"],
})
export class CentroOperationDataCardComponent
  implements OnInit, AfterContentChecked
{
  @Input() centro!: CentrosViewModel;
  @Input() parent: CentroPageComponent;
  @Output() operationFormComplete = new EventEmitter<boolean>();
  @Output() centroOperationData = new EventEmitter<FormGroup>();

  public primaIncluidaList: PrimaIncluidaViewModel[] = [];
  public desnitrificacionList: DesnitrificacionViewModel[] = [];
  public digestionAnaerobiaFangoList: DigestionAnaerobiaFangoViewModel[] = [];
  public recuperacionFosforoList: RecuperacionFosforoViewModel[] = [];
  public usoAguaProductoList: TipoUsoAguaViewModel[] = [];
  public usoAguaRegeneradaList: TipoUsoAguaViewModel[] = [];

  myOperationForm: FormGroup;
  countControls: number = 0;
  countFilled: number = 0;

  constructor(
    private readonly _masterService: MasterService,
    public renderer: Renderer2,
    public el: ElementRef,
    private readonly fb: FormBuilder,
    public decimalService: DecimalService
  ) {}

  // Events
  async ngOnInit() {
    this._loadData();
    await this.loadCentroOperationDataFormGroup();
  }

  private _loadData(): void {
    forkJoin([
      this._masterService.getPrimaIncluidaList(),
      this._masterService.getDesnitrificacionList(),
      this._masterService.getDigestionAnaerobiaFangoList(),
      this._masterService.getRecuperacionFosforoList(),
      this._masterService.getUsoAgua(true, false),
      this._masterService.getUsoAgua(false, true),
    ]).subscribe(([s1, s2, s3, s4, s5, s6]) => {
      this.primaIncluidaList = s1;
      this.desnitrificacionList = s2;
      this.digestionAnaerobiaFangoList = s3;
      this.recuperacionFosforoList = s4;
      this.usoAguaProductoList = s5;
      this.usoAguaRegeneradaList = s6;
    });
  }

  ngAfterContentChecked(): void {
    this.getFormStatus();
  }

  async loadCentroOperationDataFormGroup() {
    this.myOperationForm = this.fb.group({
      conEnerAn: [this.centro?.conEnerAn],
      conEnerAnAut: [this.centro?.conEnerAnAut],
      primaIncluidaID: [this.centro?.primaIncluidaID],
      desnitrificacionID: [this.centro?.desnitrificacionID],
      digestionAnaerobiaFangoID: [this.centro?.digestionAnaerobiaFangoID],
      recupFosforoID: [this.centro?.recupFosforoID],
      producAgua: [this.centro?.producAgua],
      volumenFacturado: [this.centro?.volumenFacturado],
      voluRecoSan: [this.centro?.voluRecoSan],
      usoPriPorc: [
        this.centro?.usoPriPorc,
        [Validators.max(100), Validators.min(0)],
      ],
      usoPriAguaProdID: [this.centro?.usoSecAguaProdID],
      usoPriPorcRege: [
        this.centro?.usoPriPorcRege,
        [Validators.max(100), Validators.min(0)],
      ],
      usoPriAguaRegeID: [this.centro?.usoPriAguaRegeID],
      usoSecPorc: [
        this.centro?.usoSecPorc,
        [Validators.max(100), Validators.min(0)],
      ],
      usoSecAguaProdID: [this.centro?.usoSecAguaProdID],
      poblaAbaste: [this.centro?.poblaAbaste],
      iLI: [this.centro?.iLI],
      cecoaCentro: [this.centro?.cecoaCentro],
    });

    this.centroOperationData.emit(this.myOperationForm);

    this.myOperationForm.valueChanges.subscribe(() => {
      this.getFormStatus();

      this.centroOperationData.emit(this.myOperationForm);
    });
  }

  getFormStatus() {
    this.countControls = 0;
    this.countFilled = 0;

    Object.keys(this.myOperationForm.controls).forEach((controlName) => {
      const control = this.myOperationForm.get(controlName);

      const controlElement = document.querySelector(
        `[formControlName="${controlName}"]`
      );

      if (controlElement) {
        const hasHiddenClass =
          controlElement.parentElement.classList.contains("hidden");

        if (!hasHiddenClass) {
          this.countControls++;

          if (control?.value !== null && control?.value !== "") {
            this.countFilled++;
          }
        }
      }
    });

    if (this.countFilled !== 0) {
      this.operationFormComplete.emit(this.countControls == this.countFilled);
    }
  }
}
